module.exports = __webpack_public_path__ + "img/style10.5627ef67.png";